import { GenericTextFilter } from '@app/core/list-view/base-filters/GenericTextFilter';
import { createFilter } from '@app/core/list-view/types';
import { GroupFromIndex } from '@app/core/types/users';
import { parseAsString } from 'nuqs';
import { defineMessage } from 'react-intl';

/**
 * Local toolbar filters for the admin groups list (name search).
 */
export const ADMIN_GROUPS_FILTERS_CONFIG = [
  createFilter({
    name: 'name',
    label: defineMessage({
      id: 'common.text.name',
      defaultMessage: 'Nombre',
    }),
    parser: parseAsString.withDefault(''),
    isPermanent: true,
    component: GenericTextFilter,
    componentProps: {
      placeholder: defineMessage({
        id: 'admin.groups.filters.namePlaceholder',
        defaultMessage: 'Buscar por nombre',
      }),
      sx: {
        width: '22ch',
      },
    },
    filterFn: (item, value) => {
      const group = item as GroupFromIndex;
      const q = typeof value === 'string' ? value.trim().toLowerCase() : '';
      if (!q) {
        return true;
      }
      return group.name.toLowerCase().includes(q);
    },
  }),
];
